export default "__VITE_ASSET__Cy7r2D5c__"